///////////////////
// 
///////////////////
import { OnInit, Component, Injector, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginViewComponent } from '../../../modules/application/login/login.view.component';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';


@Component({
    selector: 'djiv-reset-password-form',
    templateUrl: './djiv-reset-password-form.component.html',
    styleUrls: ["./djiv-reset-password-form.component.css"]
})

export class DJIVResetPasswordForm implements OnInit {   

    public $changePasswordForm: FormGroup;
    public $Error: string;
    public footerMessage: string;

    protected $router: Router;

    public passwordChangeSuccess: boolean = false; 
    public requestSent: boolean = false;

    private http: HttpClient;

    constructor(protected $injector: Injector, @Optional() public parent: LoginViewComponent) {
        this.$router = $injector.get(Router);  
        this.http = $injector.get(HttpClient);

        this.$changePasswordForm = new FormGroup({
            password: new FormControl('', Validators.required),
            confirmPassword: new FormControl('', Validators.required),
            urlkey: new FormControl(this.parent.urlKey)
        });       
    }

    ngOnInit() {
        this.footerMessage = "";
    }

    changePassword() {

        if (this.$changePasswordForm.invalid) {
            this.footerMessage = "modules.Application.views.changePassword.textPasswordFormEmptyFields";
            return;
        }

        if (this.$changePasswordForm.value["password"].length < 6 || this.$changePasswordForm.value["password"].length > 20) {
            this.footerMessage = "modules.Application.views.changePassword.textPasswordMustBeOfLength";
            return;
        }
        
        if (this.$changePasswordForm.value["password"] !== this.$changePasswordForm.value["confirmPassword"]) {
            this.footerMessage = "modules.Application.views.changePassword.textPasswordsNotMatch";
            return;
        }

        const { password, urlkey } = this.$changePasswordForm.value;
        const url = `${environment.getDataProviders()["SupplierAppProvider"].serviceUri}/web/pdo/Unauthenticated/PusrBusinessEntity/ResetPassword`;

        this.http.put(url, JSON.stringify({
            newPassword: password,
            urlkey
        }),{ 
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).subscribe(result => {
            this.requestSent = true;
            this.passwordChangeSuccess = result["response"].ResponseSuccess;
        }, error => {
            this.requestSent = true;
            this.passwordChangeSuccess = false;
        });
    }

    public backBtn(){
        this.$router.navigate(['auth-callback']);
    }

}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-reset-password-form/djiv-reset-password-form.component.ts